import React from 'react';

import { useField } from 'formik';

import { twMerge } from 'tailwind-merge';

import StarRating from 'components/star-rating/star-rating';

import Typography from 'components-new/typography/typography';
import type { IconProps } from 'components-new/icon/icon';

interface StarRatingFieldProps {
  name: string;
  iconProps: Omit<IconProps, 'icon'>;
  initialValue?: number;
}
const StarRatingField: React.FC<StarRatingFieldProps> = (props) => {
  const { name, iconProps, initialValue } = props;
  const [, meta, helpers] = useField({ name, type: 'input' });

  return (
    <div className="flex flex-col gap-y-1">
      <StarRating
        name={name}
        iconProps={{
          ...iconProps,
        }}
        onChange={helpers.setValue}
        emptyStarColor={
          meta.error && meta.touched
            ? 'text-gray100 stroke-red stroke-[20px]'
            : undefined
        }
        initialValue={initialValue}
      />
      {meta.error && meta.touched && (
        <Typography
          as="p"
          variant="body-medium"
          className={twMerge('text-destructive pl-5')}
        >
          {meta.error}
        </Typography>
      )}
    </div>
  );
};

export default StarRatingField;
